<template>
  <div>
    <v-tour
      name="myTour"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    />
  </div>
</template>

<script>
export default {
  name: 'Tour',
  data: function () {
    return {
      tourSteps: [
        {
          target: '#meshWrapper', // We're using document.querySelector() under the hood
          content: `Bewegen Sie die Maus in diesem Bereich um die Sonde zu steuern.`,
          params: {
            enableScrolling: false
          }
        },
        {
          target: '#meshWrapper', // We're using document.querySelector() under the hood
          content: `Nutzen Sie die Tasten <kbd>W</kbd>, <kbd>A</kbd>, <kbd>S</kbd>, <kbd>D</kbd> zur Rotation der Sonde.`,
          params: {
            enableScrolling: false
          }
        },
        {
          target: '#sliceWrapper', // We're using document.querySelector() under the hood
          content: `Hier wird Ihnen das Schnittbild angezeigt.`,
          params: {
            enableScrolling: false
          }
        },
        {
          target: '#solution-four-wrapper', // We're using document.querySelector() under the hood
          content: `Klicken Sie auf eine Lösungsmöglichkeit um zu lösen.`,
          params: {
            enableScrolling: false
          }
        },
        {
          target: '#solution-four-wrapper', // We're using document.querySelector() under the hood
          content: `Nutzen Sie die Tasten <kbd>Q</kbd> und <kbd>E</kbd> um die Lösungsmöglichkeiten zu drehen.`,
          params: {
            enableScrolling: false
          }
        }
      ],
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Tour überspringen',
          buttonPrevious: 'Zurück',
          buttonNext: 'Weiter',
          buttonStop: 'Verstanden'
        }
      },
      tourCallbacks: {
        onStart: this.tourStartCallback,
        onNextStep: this.tourNextStepCallback,
        onStop: this.tourStopCallback,
        onPreviousStep: this.tourPreviousStepCallback
      },
      currentStep: undefined,
      currentTarget: undefined,
      myTour: this.$tours['myTour']
    }
  },
  methods: {
    start () {
      this.$tours['myTour'].start()
    },
    tourStopCallback () {
      this.currentStep = undefined
      this.$emit('currentStep', this.currentStep)
      this.$emit('done', true)
    },
    tourStartCallback () {
      this.currentStep = 0
      this.$emit('currentStep', this.currentStep)

      this.currentTarget = this.tourSteps[this.currentStep].target
      this.$emit('currentTarget', this.currentTarget)
    },
    tourNextStepCallback (currentStep) {
      this.currentStep = currentStep + 1
      this.$emit('currentStep', this.currentStep)

      this.currentTarget = this.tourSteps[this.currentStep].target
      this.$emit('currentTarget', this.currentTarget)
    },
    tourPreviousStepCallback (currentStep) {
      this.currentStep = currentStep - 1
      this.$emit('currentStep', this.currentStep)

      this.currentTarget = this.tourSteps[this.currentStep].target
      this.$emit('currentTarget', this.currentTarget)
    }
  }
}
</script>
